<template>
  <div class="popup">
    <div
      class="popup__inner"
      :class="{ 'popup-message__inner_with_in_modal': withInModal }"
    >
      <div
        class="popup__content"
        v-click-outside="close"
        :class="{ _center: message }"
      >
        <div class="popup__content-text">
          <slot />
        </div>
        <div class="popup__content-actions">
          <template v-if="agree">
            <PrimaryButton @click.prevent="confirm">
              OK
            </PrimaryButton>
            <a href="#" class="popup__content-close" @click.prevent="close">
              {{ $t("common.cancelBtn") }}
            </a>
          </template>
          <template v-if="remove">
            <PrimaryButton @click.prevent="confirm">
              <slot name="delete"> {{ $t("events.popupClassicDelete") }}</slot>
            </PrimaryButton>
            <a href="#" class="popup__content-close" @click.prevent="close">
              <slot name="cancel"> {{ $t("events.popupClassicCancel") }}</slot>
            </a>
          </template>
          <template v-if="message">
            <PrimaryButton @click.prevent="close">OK</PrimaryButton>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PrimaryButton } from "@v2/shared/ui/components";

export default {
  name: "Popup",
  components: { PrimaryButton },
  props: {
    agree: {
      type: Boolean,
      default: false
    },
    remove: {
      type: Boolean,
      default: false
    },
    message: {
      type: Boolean,
      default: false
    },
    withInModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/media";
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(#000, 0.5);
  z-index: 900;
  &__inner {
    height: 100%;

    &_with_in_modal {
      width: 80vw;
      margin-left: 20vw;

      @include respond-down(md) {
        width: 100vw;
        margin-left: 0;
      }
    }
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__content {
    max-width: 380px;
    min-height: 100px;
    border-radius: 2px;
    background-color: #ffffff;
    padding: 24px 24px 24px 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &._center {
      align-items: center;
    }
    &-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 70%;
    }
    &-text {
      font-size: 16px;
      font-weight: normal;
      line-height: 1.5;
      color: #505050;
      margin: 0 0 22px 0;
    }
    &-close {
      font-size: 13px;
      line-height: 1.54;
      color: #6d7179;
      text-decoration: none;
      border-bottom: 1px solid #a3a8b3;
      transition: border-bottom-color 0.3s;
      margin-left: 32px;
    }
  }
}
</style>
